import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
// import * as Cookies from 'js-cookie'
// import all stores for the game
import { state, mutations, actions, getters } from './root/index'
// TODO make import nicer
import { loginRegisterStore } from './modules/login_register'
import { changelogStore } from './modules/changelog'
import { moneyStore } from './modules/money'
import { managerStore } from './modules/manager'
import { fahrzeugStore } from './modules/fahrzeug'
import { kegelbahnStore } from './modules/kegelbahn'
import { teamStore } from './modules/team'
import { saisonStore } from './modules/saison'

// import {chatStore} from './modules/chat'
// import Ws from '@adonisjs/websocket-client'
// import createWebSocketPlugin from './plugins/websocket'

Vue.use(Vuex)

// let ws = Ws(process.env.VUE_APP_WS_URL)
// const socketPlugin = createWebSocketPlugin(ws)

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    loginRegisterStore,
    changelogStore,
    moneyStore,
    managerStore,
    teamStore,
    saisonStore,
    fahrzeugStore,
    kegelbahnStore
  },
  // plugins
  plugins: [
    // socketPlugin,
    // createPersistedState({
    //   storage: {
    //     getItem: key => Cookies.get(key),
    //     // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
    //     setItem: (key, value) =>
    //       Cookies.set(key, value, { expires: 1, secure: true }),
    //     removeItem: key => Cookies.remove(key),
    //   }
    // })
    // createPersistedState({
    //   key: process.env.VUE_APP_KMO_SESSION_NAME,
    //   storage: window.sessionStorage
    // })
  ]
})
